module.exports = __webpack_public_path__ + "img/李丽菊.9c7fdc61.jpg";